export default "__VITE_ASSET__1fad5419__"